import BigNumber from 'bignumber.js';

/**
 * Adds two values together avoiding Javascripts floating point number accuracy issue.
 * @param {Number} value1
 * @param {Number} value2
 * @param {Number} decimalPlaces
 */
export const add = (value1, value2, decimalPlaces = 2) => {
  return Number(new BigNumber(value1).plus(value2).toFixed(decimalPlaces));
};

/**
 * Subtracts one value from the other avoiding Javascripts floating point number accuracy issue.
 * @param {Number} value1
 * @param {Number} value2
 * @param {Number} decimalPlaces
 */
export const subtract = (value1, value2, decimalPlaces = 2) => {
  return Number(new BigNumber(value1).minus(value2).toFixed(decimalPlaces));
};

/**
 * Multiplies two values together avoiding Javascript's floating point number
 * accuracy issue.
 * @param {Number} multiplier
 * @param {Number} multiplicand
 * @param {Number} decimalPlaces
 */
export const multiply = (multiplier, multiplicand, decimalPlaces = 2) => {
  return Number(
    new BigNumber(multiplier).times(multiplicand).toFixed(decimalPlaces)
  );
};

/**
 * @param {Number} value
 * @param {Number} percentage
 * @param {Number} decimalPlaces
 */
export const percentage = (value, percentage, decimalPlaces = 2) => {
  return Number(
    new BigNumber(value)
      .multipliedBy(percentage)
      .dividedBy(100)
      .toFixed(decimalPlaces)
  );
};



// WEBPACK FOOTER //
// ./src/common/Helpers/currency.js